export default Object.freeze({
	NEXT_STEP: "NextStep",
	PREVIOUS_STEP: "PreviousStep",
	BUTTONS: "Buttons",
	CENTERED_IMAGE: "CenteredImage",
	HEADERS: "Headers",
	INSETS: "Insets",
	OPTIONS: "Options",
	PROCEDURE_COMMIT: "ProcedureCommit",
	PROJECT_OPTIONS: "ProjectOptions",
	PROPERTIES: "Properties",
	CONTAINER: "Container",
	TEXT_DESCRIPTION: "TextDescription",
	VOICE: "Voice",
	BACKGROUND_IMAGE: "Background Image",
	CONTINUE_BUTTON: "Continue Button",
	RETRY_BUTTON: "Try Again Button",
	SCORE_NUMBER: "Score Number",
});
